import AdjustIcon from '@mui/icons-material/Adjust';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { Avatar, Box, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import SpriteIcon from '../../../core-components/assets/Icon';
import { Notification } from '../types';

interface NotificationHeaderProps {
  notification: Notification;
  handleStatus: any
}

const headerContainerStyles = {
  display: 'flex',
  width: '100%',
  gap: 2,
};

const contentContainerStyles = {
  flex: 1,
};

const headerInfoStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  mb: 0.5,
};

const nameContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2
};

const actionsContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

const timestampStyles = {
  whiteSpace: 'nowrap',
};

const getIconButtonStyles = (read: boolean) => ({
  width: 20,
  height: 20,
  border: `2px solid ${read ? '#1976d2' : '#ccc'}`,
  borderRadius: '50%',
});

const NotificationHeader: React.FC<NotificationHeaderProps> = ({ notification, handleStatus }) => {
  const isRead = notification.status === 'read';

  const handleReadToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleStatus({
      notificationId: notification._id,
      action: isRead ? 'unread' : 'read',
    });
  };

  return (
    <Box sx={headerContainerStyles}>
      {notification.iconId ? (
        <SpriteIcon id={notification.iconId} size='30' />
      ) : (
        <Avatar />
      )}

      <Box sx={contentContainerStyles}>
        <Box sx={headerInfoStyles}>
          <Box sx={nameContainerStyles}>
            <Stack direction='row' alignItems='center' gap={3}>
              <Typography variant="h4" color="text.secondary" sx={{ fontWeight: 600, gap: 2 }}>
                {notification.eventType}
              </Typography>
                <SpriteIcon id={notification.priority} size='14'/>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {notification.eventMessage}
            </Typography>
          </Box>

          <Box sx={actionsContainerStyles}>
            <Typography variant="caption" color="text.secondary" sx={timestampStyles}>
              {format(Number(notification.timestamp), 'MMM d, yyyy, h:mm a')}
            </Typography>

            <IconButton
              size="small"
              sx={getIconButtonStyles(isRead)}
              onClick={handleReadToggle}
              title={isRead ? 'Mark as unread' : 'Mark as read'}
            >
            { isRead ? <AdjustIcon /> :
              <PanoramaFishEyeIcon color='Primary.main'/> }
            </IconButton>

            {/* <IconButton
              size="small"
              sx={{ width: 32, height: 32 }}
              onClick={notification.uri}
              title="View details"
            >
              <EastIcon />
            </IconButton> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationHeader;